import { SVGProps } from "react";

export const CartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14.63 16.84"
    {...props}
  >
    <path d="M13.96,5.94c-.02-.35-.19-.67-.42-.87-.24-.25-.57-.38-.91-.38h-1.7v-1.01c0-.98-.37-1.91-1.06-2.62-1.36-1.41-3.77-1.41-5.13,0-.69.71-1.06,1.64-1.06,2.62v1.01h-1.68c-.34,0-.67.14-.88.35-.27.23-.43.55-.45.89L0,14.54c-.02.29.01.57.11.88.11.3.26.54.44.73.19.21.42.38.69.51.27.12.55.18.84.18h10.46c.29,0,.56-.07.85-.19.26-.12.48-.29.67-.49.18-.2.33-.44.45-.77.08-.27.11-.55.1-.84h0s-.67-8.61-.67-8.61ZM4.81,3.68c0-.69.26-1.34.74-1.83.93-.97,2.58-.97,3.51,0,.48.49.74,1.15.74,1.83v1.01h-5v-1.01ZM13.46,15c-.06.16-.14.28-.21.37-.09.1-.2.18-.32.24-.14.07-.26.09-.39.09H2.1c-.14,0-.26-.02-.38-.08-.14-.06-.24-.15-.34-.25-.08-.09-.15-.2-.2-.34-.06-.14-.06-.28-.06-.43l.67-8.62s.02-.09.08-.13c.03-.02.12-.05.12-.05h0s1.69-.01,1.69-.01v1.81c0,.31.25.56.56.56s.56-.25.56-.56v-1.81h5v1.81c0,.31.25.56.56.56s.56-.25.56-.56v-1.81h1.69s.09.02.16.08c.02.02.06.12.06.12l.67,8.59c0,.16-.01.3-.04.4Z" />
  </svg>
);
